import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateVideoSeasonFailAction,
  CreateVideoSeasonSuccessAction,
  DeleteVideoSeasonSuccessAction,
  DeleteVideoSeasonSuccessFail,
  FetchVideoSeasonFailureAction,
  FetchVideoSeasonRequestAction,
  FetchVideoSeasonSuccessAction,
  stateStatusType,
  UpdateVideoSeasonFailAction,
  UpdateVideoSeasonSuccessAction,
  VideoSeasonActions,
} from "./actionType";
import { VideoSeasonsState, initialState } from "./state";
import { error } from "console";

//FetchVideoSeasonsRequest
const FetchVideoSeasonRequest = (
  state: VideoSeasonsState,
  action: FetchVideoSeasonRequestAction
) => {
  return updateObject(state, {
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchVideoSeasonSuccess = (
  state: VideoSeasonsState,
  action: FetchVideoSeasonSuccessAction
) => {
  return updateObject(state, {
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_seasons: action.payload,
    },
  });
};

const FetchVideoSeasonFail = (
  state: VideoSeasonsState,
  action: FetchVideoSeasonFailureAction
) => {
  return updateObject(state, {
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      video_seasons: null,
    },
  });
};

//create season
const CreateVideoSeasonSuccess = (
  state: VideoSeasonsState,
  action: CreateVideoSeasonSuccessAction
) => {
  const newSeasonVideo = state.videoSeasonsState.video_seasons ?? [];
  return updateObject(state, {
    genericVideoSeasonState: {
      ...state.genericVideoSeasonState,
      isLoading: false,
      error: null,
    },
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: null,
      state: stateStatusType.SUCCESS,
      video_seasons: [...newSeasonVideo, action.payload],
    },
  });
};
const CreateVideoSeasonFail = (
  state: VideoSeasonsState,
  action: CreateVideoSeasonFailAction
) => {
  return updateObject(state, {
    genericVideoSeasonState: {
      ...state.genericVideoSeasonState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
  });
};

//update season
const UpdateVideoSeasonSuccess = (
  state: VideoSeasonsState,
  action: UpdateVideoSeasonSuccessAction
) => {
  const newSeasonVideo =
    state.videoSeasonsState.video_seasons.map((items) =>
      items.id === action.payload.id ? action.payload : items
    ) ?? [];
  return updateObject(state, {
    genericVideoSeasonState: {
      ...state.genericVideoSeasonState,
      isLoading: false,
      error: null,
    },
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: null,
      state: stateStatusType.SUCCESS,
      video_seasons: [...newSeasonVideo],
    },
  });
};
const UpdateVideoSeasonFail = (
  state: VideoSeasonsState,
  action: UpdateVideoSeasonFailAction
) => {
  return updateObject(state, {
    genericVideoSeasonState: {
      ...state.genericVideoSeasonState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
  });
};

//delete season
const DeleteVideoSeasonSuccess = (
  state: VideoSeasonsState,
  action: DeleteVideoSeasonSuccessAction
) => {
  const newSeasonVideo = state.videoSeasonsState.video_seasons.filter(
    (items) => items.id !== action.payload
  );
  return updateObject(state, {
    genericVideoSeasonState: {
      ...state.genericVideoSeasonState,
      isLoading: false,
      error: null,
    },
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: null,
      state: stateStatusType.SUCCESS,
      video_seasons: [...newSeasonVideo],
    },
  });
};
const DeleteVideoSeasonFail = (
  state: VideoSeasonsState,
  action: DeleteVideoSeasonSuccessFail
) => {
  return updateObject(state, {
    genericVideoSeasonState: {
      ...state.genericVideoSeasonState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
    videoSeasonsState: {
      ...state.videoSeasonsState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
  });
};
const VideoSeasonsReducer = (
  state = initialState,
  action: VideoSeasonActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_VIDEO_SEASON_REQUEST:
      return FetchVideoSeasonRequest(state, action);
    case actionTypes.FETCH_VIDEO_SEASON_SUCCESS:
      return FetchVideoSeasonSuccess(state, action);
    case actionTypes.FETCH_VIDEO_SEASON_FAIL:
      return FetchVideoSeasonFail(state, action);
    case actionTypes.CREATE_VIDEO_SEASON_SUCCESS:
      return CreateVideoSeasonSuccess(state, action);
    case actionTypes.CREATE_VIDEO_SEASON_FAIL:
      return CreateVideoSeasonFail(state, action);
    case actionTypes.UPDATE_VIDEO_SEASON_SUCCESS:
      return UpdateVideoSeasonSuccess(state, action);
    case actionTypes.UPDATE_VIDEO_SEASON_FAIL:
      return UpdateVideoSeasonFail(state, action);
    case actionTypes.DELETE_VIDEO_SEASON_SUCCESS:
      return DeleteVideoSeasonSuccess(state, action);
    case actionTypes.DELETE_VIDEO_SEASON_FAIL:
      return DeleteVideoSeasonFail(state, action);
    default:
      return state;
  }
};

export default VideoSeasonsReducer;
